import { createContext, useContext } from "react";

// Lets Radix portaled content (Dialog/Select/DropdownMenu/Popover/AlertDialog) render
// INSIDE the authenticated app shell's DOM subtree instead of document.body, so it
// inherits the shell's .co-scope/.co-settings dark-theme CSS variables automatically.
// Unauthenticated pages (login, customer/technician portal login) never provide this
// context, so their portaled content keeps rendering to document.body exactly as before.
export const PortalContainerContext = createContext(null);

export const usePortalContainer = () => useContext(PortalContainerContext) || undefined;
